import { TOGGLE_SIDEMENU, TOGGLE_NAV } from "../constants/action-types";

export const toggleMenu = sidemenuOn => ({
  type: TOGGLE_SIDEMENU,
  payload: sidemenuOn
});

export const toggleNav = navToggleOn => ({
  type: TOGGLE_NAV,
  payload: navToggleOn
});
